module.exports = __webpack_public_path__ + "img/ic-man.6dc0065c.svg";